import { ROUTE_IDS } from '@/app/router/route-constants';
import { DASHBOARD_SECTION_IDS } from '@/modules/dashboard/dashboard-sections';
import { tenantTheme } from './tenant-theme';
import { tenantNavigation } from './tenant-navigation';

export const defaultTenantId = 'webtika-default';
const labTenantId = 'webtika-lab';

const enabledModuleKeys = [
  'dashboard',
  'deals',
  'clients',
  'suppliers',
  'staff',
  'calendar',
  'documents',
  'accounting',
  'settings',
];

const visibleRouteIds = [
  ROUTE_IDS.DASHBOARD,
  ROUTE_IDS.ASSIGNMENTS,
  ROUTE_IDS.DEAL_PROPOSALS,
  ROUTE_IDS.DEALS_IN_PROGRESS,
  ROUTE_IDS.DEALS_COMPLETED,
  ROUTE_IDS.CLIENTS,
  ROUTE_IDS.SUPPLIERS,
  ROUTE_IDS.SUPPLIER_DETAIL,
  ROUTE_IDS.STAFF,
  ROUTE_IDS.CALENDAR,
  ROUTE_IDS.DOCUMENTS,
  ROUTE_IDS.ACCOUNTING,
  ROUTE_IDS.EXPENSES,
  ROUTE_IDS.WORKSPACE_USERS,
  ROUTE_IDS.SETTINGS,
  ROUTE_IDS.CLIENTS_LEGACY_REDIRECT,
  ROUTE_IDS.SUPPLIERS_LEGACY_REDIRECT,
];

function createTenantConfig({ id, key, name }) {
  return {
    id,
    key,
    name,
    defaultRouteId: ROUTE_IDS.DASHBOARD,
    branding: tenantTheme.branding,
    theme: tenantTheme.theme,
    navigation: {
      items: tenantNavigation,
    },
    access: {
      enabledModuleKeys,
      visibleRouteIds,
    },
    dashboard: {
      visibleSectionIds: [
        DASHBOARD_SECTION_IDS.STATS_CARDS,
        DASHBOARD_SECTION_IDS.ACCOUNTING_OVERVIEW,
        DASHBOARD_SECTION_IDS.ASSIGNMENTS_OVERVIEW,
        DASHBOARD_SECTION_IDS.DEALS_OVERVIEW,
        DASHBOARD_SECTION_IDS.CLIENTS_OVERVIEW,
      ],
    },
    labels: tenantTheme.labels,
  };
}

export const tenantConfigs = {
  [defaultTenantId]: createTenantConfig({
    id: defaultTenantId,
    key: 'webtika',
    name: 'Webtika Default',
  }),
  [labTenantId]: createTenantConfig({
    id: labTenantId,
    key: 'webtika-lab',
    name: 'Webtika Lab',
  }),
};

export function resolveTenantConfig(tenantId = defaultTenantId) {
  return tenantConfigs[tenantId] || tenantConfigs[defaultTenantId];
}
